import { ECompanyType, EProductType, zSchema } from "@zeal/common";

export const postGenerateCompanyOnboardingShareableLinkSchema = zSchema.object({
  partnerID: zSchema.string(),
  companyID: zSchema.string().nullish(),
  company_type: zSchema.nativeEnum(ECompanyType),
  product_type: zSchema.nativeEnum(EProductType),
  webhook_correlation_id: zSchema.string().optional(),
  skip_migration: zSchema.boolean(),
  testMode: zSchema.boolean().optional(),
});

export type TPostGenerateCompanyOnboardingShareableLinkRequest = zSchema.infer<
  typeof postGenerateCompanyOnboardingShareableLinkSchema
>;
